import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import styles from "./NormalButton.module.scss";
import { CaretRightIcon, LoadingIcon, PlusIcon } from "@/frontend/shared/assets/icons";
import clsx from "clsx";

type TNormalButtonProps = {
  children?: ReactNode;
  className?: string;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  size?: "small" | "medium" | "large";
  variant?: "primary" | "secondary" | "tertiary";
  color?:
    | "greyscale100"
    | "greyscale200"
    | "greyscale300"
    | "greyscale400"
    | "greyscale500"
    | "greyscale600"
    | "greyscale700"
    | "greyscale800"
    | "greyscale900";
  leftIcon?: ReactNode | boolean;
  rightIcon?: ReactNode;
  type?: "button" | "submit" | "reset";
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const NormalButton = forwardRef<HTMLButtonElement, TNormalButtonProps>(function (props, ref) {
  const {
    children,
    className,
    isDisabled = false,
    isSubmitting = false,
    variant = "primary",
    size = "small",
    leftIcon,
    rightIcon,
    color,
    ...otherProps
  } = props;

  // Medium button size is deprecated
  // TODO: change all medium buttons to large - A.
  const newSize = size === "medium" ? "large" : size;

  return (
    <button
      className={clsx(
        styles.btn,
        isDisabled && styles.disabled,
        isSubmitting && styles.isSubmitting,
        rightIcon && !isSubmitting && styles.hasRightIcon,
        styles[variant],
        styles[newSize],
        className
      )}
      disabled={isDisabled || isSubmitting}
      style={color && { color: `var(--${color})` }}
      ref={ref}
      {...otherProps}
    >
      {leftIcon &&
        !isSubmitting &&
        (leftIcon === true ? <PlusIcon style={{ stroke: `var(--${color})` }} className={styles.leftIcon} /> : leftIcon)}
      {isSubmitting ? <LoadingIcon className={styles.loadingIcon} /> : children}
      {rightIcon && !isSubmitting && (
        <CaretRightIcon className={styles.rightIcon} style={color && { stroke: `var(--${color})` }} />
      )}
    </button>
  );
});
